var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcHelp = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "lm5s7t6ska",
    d: "M10 1.667C5.4 1.667 1.667 5.4 1.667 10S5.4 18.333 10 18.333 18.333 14.6 18.333 10 14.6 1.667 10 1.667zm.833 14.166H9.167v-1.666h1.666v1.666zm1.725-6.458l-.75.767c-.6.608-.975 1.108-.975 2.358H9.167v-.417c0-.916.375-1.75.975-2.358l1.033-1.05c.308-.3.492-.717.492-1.175 0-.917-.75-1.667-1.667-1.667s-1.667.75-1.667 1.667H6.667c0-1.842 1.491-3.333 3.333-3.333s3.333 1.491 3.333 3.333c0 .733-.3 1.4-.775 1.875z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "5kz4gjcn0b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lm5s7t6ska"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#BEC4CA",
    mask: "url(#5kz4gjcn0b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H41.667V41.667H0z",
    transform: "translate(-10.833 -10.833)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcHelp, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-help.8e498345.svg";
export { ForwardRef as ReactComponent };